import firebase from "firebase/compat/app";
import "firebase/compat/storage";
import "firebase/compat/firestore";
import "firebase/compat/auth";

const firebaseConfig = {
  apiKey: "AIzaSyA83BMkWTMpLuO9Ndic3uCuK9cf6RTJLI0",
  authDomain: "survey-fcd0e.firebaseapp.com",
  projectId: "survey-fcd0e",
  storageBucket: "survey-fcd0e.appspot.com",
  messagingSenderId: "293049940269",
  appId: "1:293049940269:web:380af962c0931a3ad2bba4",
  measurementId: "G-VXWJ91P33K",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const auth = firebase.auth();
const storage = firebase.storage();
const db = firebase.firestore();

export { storage, db, auth };
export default firebase;
